import { Calendar, MapPin, Trophy, Clock, ArrowLeft } from "@phosphor-icons/react"
import { useNavigate } from "react-router-dom"

const pastEvents = [
  {
    title: "2-Day Football Scouting Competition",
    badge: "ZOE Football Academy Presents",
    date: "2nd & 3rd May 2026",
    time: "8:00 AM - 6:00 PM",
    venue: "Suleja Township Stadium",
    location: "Suleja, Nigeria",
    prize: "₦50,000",
    prizeNote: "Cash + Scouting Opportunities",
    description:
      "A premier scouting event showcasing emerging football talent with professional evaluation and assessment.",
    highlights: [
      "Professional scouting and evaluation",
      "Technical skills assessment",
      "Game intelligence tests",
      "Physical fitness evaluation",
      "Networking with coaches and scouts",
    ],
  },
]

export function EventsPage() {
  const navigate = useNavigate()

  return (
    <div className="min-h-screen bg-gradient-to-br from-ivory via-ivory to-muted pt-32 pb-20">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Back to Home */}
        <button
          onClick={() => navigate("/")}
          className="inline-flex items-center gap-2 text-navy-muted hover:text-navy transition-colors mb-8 bg-white/90 backdrop-blur-sm px-4 py-2 rounded-lg shadow-sm"
        >
          <ArrowLeft className="w-5 h-5" />
          <span>Back to Home</span>
        </button>

        {/* Page Title */}
        <h1 className="font-serif text-4xl sm:text-5xl font-semibold text-navy mb-10">Events</h1>

        {/* Past Events */}
        {pastEvents.length > 0 ? (
          <div className="space-y-8">
            {pastEvents.map((event, index) => (
              <div
                key={index}
                className="bg-white rounded-2xl shadow-xl border border-gold/10 overflow-hidden"
              >
                {/* Past Event Label */}
                <div className="bg-navy px-6 py-3 flex items-center justify-center gap-3">
                  <div className="w-2 h-2 rounded-full bg-ivory/40" />
                  <span className="text-ivory/60 text-sm uppercase tracking-wider font-medium">
                    Past Event
                  </span>
                </div>

                <div className="p-6 sm:p-8">
                  {/* Badge */}
                  <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-gold/15 text-gold text-sm font-semibold uppercase tracking-wider border border-gold/20 mb-4">
                    <Trophy className="w-4 h-4" weight="fill" />
                    {event.badge}
                  </div>

                  {/* Title */}
                  <h2 className="font-serif text-2xl sm:text-3xl font-semibold text-navy mb-6">
                    {event.title}
                  </h2>

                  {/* Event Details */}
                  <div className="grid sm:grid-cols-3 gap-6 mb-8">
                    {/* Date & Time */}
                    <div className="flex items-start gap-3">
                      <div className="w-10 h-10 rounded-xl bg-gold/10 flex items-center justify-center flex-shrink-0 border border-gold/10">
                        <Calendar className="w-5 h-5 text-gold" weight="duotone" />
                      </div>
                      <div>
                        <p className="text-xs text-navy-muted uppercase tracking-wider font-medium mb-1">Date</p>
                        <p className="text-navy font-semibold">{event.date}</p>
                        <div className="flex items-center gap-1.5 mt-1 text-navy-muted text-sm">
                          <Clock className="w-3.5 h-3.5" weight="fill" />
                          <span>{event.time}</span>
                        </div>
                      </div>
                    </div>

                    {/* Venue */}
                    <div className="flex items-start gap-3">
                      <div className="w-10 h-10 rounded-xl bg-gold/10 flex items-center justify-center flex-shrink-0 border border-gold/10">
                        <MapPin className="w-5 h-5 text-gold" weight="duotone" />
                      </div>
                      <div>
                        <p className="text-xs text-navy-muted uppercase tracking-wider font-medium mb-1">Venue</p>
                        <p className="text-navy font-semibold">{event.venue}</p>
                        <p className="text-navy-muted text-sm mt-1">{event.location}</p>
                      </div>
                    </div>

                    {/* Prize */}
                    <div className="flex items-start gap-3">
                      <div className="w-10 h-10 rounded-xl bg-gold flex items-center justify-center flex-shrink-0">
                        <Trophy className="w-5 h-5 text-navy" weight="fill" />
                      </div>
                      <div>
                        <p className="text-xs text-navy-muted uppercase tracking-wider font-medium mb-1">Prize</p>
                        <p className="text-navy font-bold text-xl">{event.prize}</p>
                        <p className="text-gold text-sm font-medium mt-1">{event.prizeNote}</p>
                      </div>
                    </div>
                  </div>

                  {/* Description */}
                  <p className="text-navy-muted mb-6">{event.description}</p>

                  {/* Highlights */}
                  <div className="space-y-3">
                    <h4 className="text-navy font-semibold text-sm uppercase tracking-wider">Highlights</h4>
                    <div className="grid sm:grid-cols-2 gap-3">
                      {event.highlights.map((highlight, idx) => (
                        <div key={idx} className="flex items-center gap-3">
                          <div className="w-2 h-2 rounded-full bg-gold flex-shrink-0" />
                          <span className="text-navy-muted text-sm">{highlight}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="text-center py-20">
            <p className="text-navy-muted text-lg">No events available at this time.</p>
          </div>
        )}
      </div>
    </div>
  )
}
